import { useState } from 'react';

import type { IFieldAction } from '@customTypes/Common';

import EyeIcon from '@assets/Icons/Eye';
import EyeOffIcon from '@assets/Icons/EyeOff';

import styles from './styles.module.scss';

export enum TEXT_INPUT_SIZE {
  STANDARD = 'standard',
  COMPRESSED = 'compressed',
}

export interface ITextInput {
  label?: string;
  name: string;
  value?: string;
  placeholder?: string;
  disabled?: boolean;
  isPassword?: boolean;
  size?: TEXT_INPUT_SIZE;
  error?: string;
  onChange: React.ChangeEventHandler;
  onBlur?: React.FocusEventHandler;
  action?: IFieldAction;
  maxLength?: number;
}

const TextInput = ({
  label,
  name,
  value = '',
  placeholder,
  disabled = false,
  isPassword = false,
  size = TEXT_INPUT_SIZE.STANDARD,
  error,
  onChange,
  onBlur,
  action,
  maxLength,
}: ITextInput) => {
  const className = `text-input ${size === TEXT_INPUT_SIZE.COMPRESSED ? 'text-input--compressed' : ''} ${error ? 'text-input--error' : ''} `;

  const [shouldShowPassword, setShouldShowPassword] = useState(false);
  const togglePassword = () => setShouldShowPassword(!shouldShowPassword);

  return (
    <div className={styles.container}>
      {label && (
        <label htmlFor={name}>
          {label}
          {action && (
            <button className={styles.action} onClick={action.onClick}>
              {action.label}
            </button>
          )}
        </label>
      )}
      <div className={styles.wrapper}>
        <input
          onBlur={onBlur}
          type={!isPassword || shouldShowPassword ? 'text' : 'password'}
          name={name}
          value={value}
          onChange={onChange}
          className={className}
          placeholder={placeholder}
          disabled={disabled}
          maxLength={maxLength}
        />
        {isPassword && (
          <button type="button" className={styles.pwdToggle} onClick={togglePassword}>
            {shouldShowPassword ? <EyeOffIcon size={20} /> : <EyeIcon size={20} />}
          </button>
        )}
      </div>
      {error && <span className={styles.error}>{error}</span>}
    </div>
  );
};

export default TextInput;
